module.exports = {
  horizontalPadding: 20,
  verticalPadding: 10,
  claddingOffset: 30,
  cloakOffset: 35
}